module.exports = __webpack_public_path__ + "static/media/icon-justice.badd0136.svg";